import { extend } from "./vanilla";
import spin from "../lib/spin";

export default class Spinner {
    private readonly spinner;

    constructor(options?) {
        this.spinner = spin(this.getSpinnerOptions(options));
    }

    getSpinnerOptions(customOptions?): any {
        return extend({
            shadow: false, // Whether to render a shadow
            hwaccel: true, // Whether to use hardware acceleration
            zIndex: 2e3 // The z-index
        }, customOptions || {});
    }

    spin(target) {
        return this.spinner.spin(target);
    }

    stop() {
        return this.spinner.stop();
    }
}

export class BigSpinner extends Spinner {
    getSpinnerOptions(customOptions?): any {
        return extend({
            lines: 12, // The number of lines to draw
            length: 25, // The length of each line
            width: 11, // The line thickness
            radius: 30, // The radius of the inner circle
            corners: 1, // Corner roundness (0..1)
            rotate: 0, // The rotation offset
            direction: 1, // 1: clockwise, -1: counterclockwise
            speed: 1.3, // Rounds per second
            trail: 62, // Afterglow percentage
            shadow: false, // Whether to render a shadow
            hwaccel: true, // Whether to use hardware acceleration
            className: "spinner", // The CSS class to assign to the spinner
            zIndex: 2e3, // The z-index (defaults is 2000000000) switched to 2000
            top: "auto", // Top position relative to parent in px
            left: "auto" // Left position relative to parent in px
        }, customOptions || {});
    }
}

export function stopAllSpinners() {
    let spinners = document.querySelectorAll(".spinner");
    for (let i = 0; i < spinners.length; i++) {
        spinners[i]?.parentNode?.removeChild(spinners[i]);
    }
}